export default {
  'app.setting.pagestyle': '全体のスタイル設定',
  'app.setting.pagestyle.light': 'ライトメニュー',
  'app.setting.pagestyle.dark': 'ダークメニュー',
  'app.setting.pagestyle.realdark': 'ダークモード',
  'app.setting.themecolor': 'テーマカラー',
  'app.setting.navigationmode': 'ナビゲーションモード',
  'app.setting.content-width': 'コンテンツの幅',
  'app.setting.fixedheader': 'ヘッダーを固定',
  'app.setting.fixedsidebar': 'サイドバーを固定',
  'app.setting.multitab': 'タブを表示',
  'app.setting.sidemenu': 'サイドメニュー配置',
  'app.setting.topmenu': 'トップメニュー配置',
  'app.setting.content-width.fixed': '固定',
  'app.setting.content-width.fluid': '可変幅',
  'app.setting.othersettings': 'その他の設定',
  'app.setting.weakmode': '色覚サポートモード',
  'app.setting.copy': '設定をコピー',
  'app.setting.loading': 'テーマを読み込み中',
  'app.setting.copyinfo': '設定をコピーしました src/config/defaultSettings.js',
  'app.setting.production.hint': '設定パネルは開発環境のプレビュー用です。本番環境では表示されません。設定をコピーして設定ファイルを編集してください。',
  'app.setting.themecolor.daybreak': 'デイブレイクブルー',
  'app.setting.themecolor.dust': 'ダストレッド',
  'app.setting.themecolor.volcano': 'ボルケーノ',
  'app.setting.themecolor.sunset': 'サンセット',
  'app.setting.themecolor.cyan': 'シアン',
  'app.setting.themecolor.green': 'グリーン',
  'app.setting.themecolor.geekblue': 'ブルー',
  'app.setting.themecolor.purple': 'パープル'
}
